/* eslint-disable global-require */
const { en: common } = require("../../common");

module.exports = {
	...common,
	igem: require("./igem.json"),
};
